/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Protein_Supplement_RegularInputs */

const en_us2_protein_supplement_regular = /** @type {(inputs: Protein_Supplement_RegularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regularly`)
};

const pt_br2_protein_supplement_regular = /** @type {(inputs: Protein_Supplement_RegularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regularmente`)
};

const es_419_protein_supplement_regular = /** @type {(inputs: Protein_Supplement_RegularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regularmente`)
};

const pt_pt2_protein_supplement_regular = /** @type {(inputs: Protein_Supplement_RegularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regularmente`)
};

const fr_fr2_protein_supplement_regular = /** @type {(inputs: Protein_Supplement_RegularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Régulièrement`)
};

const de_de2_protein_supplement_regular = /** @type {(inputs: Protein_Supplement_RegularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regelmäßig`)
};

const it_it2_protein_supplement_regular = /** @type {(inputs: Protein_Supplement_RegularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regolarmente`)
};

/**
* | output |
* | --- |
* | "Regularly" |
*
* @param {Protein_Supplement_RegularInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const protein_supplement_regular = /** @type {((inputs?: Protein_Supplement_RegularInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Protein_Supplement_RegularInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_protein_supplement_regular(inputs)
	if (locale === "es-419") return es_419_protein_supplement_regular(inputs)
	if (locale === "pt-PT") return pt_pt2_protein_supplement_regular(inputs)
	if (locale === "fr-FR") return fr_fr2_protein_supplement_regular(inputs)
	if (locale === "de-DE") return de_de2_protein_supplement_regular(inputs)
	if (locale === "it-IT") return it_it2_protein_supplement_regular(inputs)
	return en_us2_protein_supplement_regular(inputs)
});
export { protein_supplement_regular as "protein_supplement.regular" }